import type { AwNuxtAppExtensions } from '~~/common/types/nuxt-app-extensions';
import type { PublicRuntimeConfig } from 'nuxt/schema';

export class BrowserStats {
  readonly _$cookies: AwNuxtAppExtensions['$cookies'];
  readonly _$logger: AwNuxtAppExtensions['$logger'];
  _browserStats: Array<[string, string, { path: string; maxAge: number; sameSite: boolean }]>;
  readonly _isSimplePayEnabled: unknown;

  // Callers pass `config.public` (PublicRuntimeConfig); the class only reads
  // `isSimplePayEnabled`, which lives on the public runtime config.
  constructor ({ config, $cookies, $logger }: {
    config: PublicRuntimeConfig,
    $cookies: AwNuxtAppExtensions['$cookies'],
    $logger: AwNuxtAppExtensions['$logger']
  }) {
    this._$cookies = $cookies;
    this._$logger = $logger;
    this._browserStats = [];
    this._isSimplePayEnabled = config.isSimplePayEnabled;
  }

  _getSimplePayStats () {
    return (this._isSimplePayEnabled
      ? {
        java: navigator.javaEnabled(),
        lang: navigator.language,
        color: screen.colorDepth,
        height: screen.height,
        width: screen.width,
        tz: new Date().getTimezoneOffset(),
      }
      : {}
    );
  }

  addStats () {
    try {
      this._browserStats = Object.entries(this._getSimplePayStats()).map(([key, value]) => [
        `browserStat_${key}`,
        value,
        {
          path: '/',
          maxAge: 30,
          sameSite: true, // strict
        },
      ]);
      this._browserStats.forEach((bs) => {
        try {
          this._$cookies.set(...bs);
        } catch (err) {
          this._$logger.error(err);
        }
      });
    } catch (err) {
      this._$logger.error(err);
    }
    return this;
  }

  removeStats () {
    try {
      this._browserStats.forEach(([key, , opts]) => {
        try {
          this._$cookies.remove(key, opts);
        } catch (err) {
          this._$logger.error(err);
        }
      });
      this._browserStats = [];
    } catch (err) {
      this._$logger.error(err);
    }
    return this;
  }

  getBrowserStatsRelatedHeaders () {
    return {
      'X-Auchan-Environment': navigator.userAgent,
      'X-Auchan-Client-Version': `auchan-vue-client_${__AW_BUILD_IDENTIFIER__}`,
      'X-Auchan-Piwik-Available': false,
      'X-Auchan-Ga-Available': Boolean(window.google_tag_manager),
    };
  }
}
